<script>
import BrandedTextElement
  from "%/dynamic-component-editor/standard-elements/text-element/BrandedTextElement.vue";
import BrandedTextOptions from "%/dynamic-component-editor/bundles/branded-text-options";
import { DynamicElementMixin } from "%/dynamic-component-editor/mixins/dynamic-element-mixin";
import DynamicElementWithContext from "%/dynamic-component-editor/mixins/dynamic-element-with-context-mixin";
import CallCountText from "%/dynamic-component-editor/options/call-count-text";
import CountFormat from "%/dynamic-component-editor/options/count-format";
import HideWhenZero from "%/dynamic-component-editor/options/hide-when-zero";
import { formatNumber } from "%/dynamic-components/render-engine/helpers/number-format";
import { ConversationCallElementMixin }
  from "%/dynamic-component-editor/standard-elements/conversation-call/conversation-call-element-mixin";

const PLACEHOLDER_COUNT = 3;
const COUNT_TOKEN = "{count}";

export default {
  name: "ConversationCallParticipantCount",
  extends: BrandedTextElement,
  mixins: [DynamicElementMixin, DynamicElementWithContext, ConversationCallElementMixin],
  elementPanelSettings: {
    displayName: "Call Participant Count",
    elementGroup: "general",
    displayIcon: "users",
    elementType: "element",
  },
  hidden: true,
  optionBundles: [
    new BrandedTextOptions({
      "default.text-style-option": "paragraph",
    }, {
      "text-option": true,
    }),
  ],
  options: [CallCountText, CountFormat, HideWhenZero],
  computed: {
    isEditable() {
      return false;
    },
    callCount() {
      return this.isCallPlaceholder ? PLACEHOLDER_COUNT : this.callPresence.count;
    },
    value() {
      if (this.callCount === 0 && this.getOptionValue(HideWhenZero)) {
        return "";
      }
      const template = String(this.getOptionValue(CallCountText) || COUNT_TOKEN);
      const count = formatNumber(this.callCount, this.getOptionValue(CountFormat));

      return template.includes(COUNT_TOKEN) ? template.split(COUNT_TOKEN).join(count) : `${count} ${template}`;
    },
    shouldShowText() {
      return Boolean(this.value) || this.editMode;
    },
  },
};
</script>
